import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import { useTranslation } from 'react-i18next';

const Footer1 = () => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [emailError, setEmailError] = useState('');

  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Email should be valid');
      return;
    }

    setEmailError('');

    const subject = 'Mailing List Signup';
const html = `
  <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9;">
    <h2 style="color: #333; text-align: center;">📬 New Mailing List Request</h2>
    <hr style="border: none; border-top: 1px solid #ccc; margin: 20px 0;" />
    <p style="font-size: 16px; color: #555;"><strong>Name:</strong> ${name}</p>
    <p style="font-size: 16px; color: #555;"><strong>Email:</strong> ${email}</p>
    <hr style="border: none; border-top: 1px solid #ccc; margin: 20px 0;" />
    <p style="font-size: 14px; color: #888; text-align: center;">This request was submitted through Miami Lakes Vision Zero website mailing list form.</p>
  </div>
`;


    try {
      await fetch('http://localhost:5000/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          toEmail: ['transportationlist@miamilakes-fl.gov'], 
          subject,
          html,
        }),
      });
    } catch (error) {
      console.error('Error sending email:', error);
    } finally {
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <Box component="footer" sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="h5" color="green">
          {t('actions.thank_you', 'Thank you! Your response has been submitted.')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'white',
        color: 'black',
        py: 6,
        px: { xs: 2, sm: 4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowX: 'hidden',
      }}
    >
      <Typography variant="h4" align="center" sx={{ mb: 3, maxWidth: '600px', width: '100%' }}>
        {t('footer1.join_mailing_list')}
      </Typography>

      <Box sx={{ textAlign: 'center', maxWidth: { xs: '90vw', sm: 400 }, width: '100%' }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {t('footer1.your_name')}
        </Typography>
        <TextField
          variant="outlined"
          placeholder={t('footer1.enter_name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          sx={{ mb: 3, backgroundColor: 'white' }}
          InputProps={{ style: { color: 'black' } }}
        />

        <Typography variant="body1" sx={{ mb: 1 }}>
          {t('footer1.your_email')}
        </Typography>
        <TextField
          variant="outlined"
          placeholder={t('footer1.enter_email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={!!emailError}
          helperText={emailError}
          fullWidth
          sx={{ mb: 3, backgroundColor: 'white' }}
          InputProps={{ style: { color: 'black' } }}
        />

        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            mb: 4,
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
            width: '100%',
          }}
        >
          {t('footer1.submit_button', 'Submit')}
        </Button>

<Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
  <Link href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
    <FacebookIcon sx={{ fontSize: { xs: 30, sm: 40 }, color: 'black' }} />
  </Link>
  <Link href="https://www.instagram.com/miamilakesvisionzero" target="_blank" rel="noopener noreferrer">
    <InstagramIcon sx={{ fontSize: { xs: 30, sm: 40 }, color: 'black' }} />
  </Link>
  <Link href="https://twitter.com/miamilakesvz" target="_blank" rel="noopener noreferrer">
    <XIcon sx={{ fontSize: { xs: 30, sm: 40 }, color: 'black' }} />
  </Link>
</Box>
      </Box>
    </Box>
  );
};

export default Footer1;
